module.exports = __webpack_public_path__ + "img/r_figure_03.1be4f4eb.png";